import Vue from "vue";
import PC from "./views/PC";
import * as filters from "./filters";
import store from "./store/";

import "./sass/global.sass";
import "./assets/sass/font.sass";

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
Vue.config.productionTip = false;
new Vue({
  store,
  render: h => h(PC)
}).$mount("#app");
